import { AdobeBaseEvent } from './adobe-base-event';
import { AnalyticsEventType } from '../models';
import { Store } from 'vuex';
import { AppState } from '@/store';
import { ServicesContainer } from '@/services';
import { RewardsLinkClickedEvent } from '@/services/analytics/events/rewards-link-clicked-event';

export class AdobeRewardsLinkClickedEvent extends AdobeBaseEvent {
    name = 'AdobeRewardsLinkClickedEvent';
    event = AnalyticsEventType.LinkClicked;

    constructor(
        event: RewardsLinkClickedEvent,
        store: Store<AppState>,
        services: ServicesContainer,
    ) {
        super(store, services);

        this.web.webPageDetails.name = `rewards:${event.pageName}`;
        this.web.webPageDetails.siteSection = 'rewards';

        this.web.webInteraction = {
            linkClicks: { value: 1 },
            name: event.linkName,
            type: 'other',
        }
    }
}